import * as React from 'react';

import './styles.scss';

import FlexContainer from 'global_elements/Layouts/FlexContainer';

import { NavBarProps } from 'types/navigationProps';
import { UserRole } from 'constants/roles';
import { MenuItem } from 'constants/routes';

import { DisplayVariant, JustifyVariant, AlignVariant } from 'global_elements/Layouts/FlexContainer/variants';
import { NavLinkVariant } from 'global_elements/Navigation/NavLinkWrapper/variants';
import { GetNavOptions } from 'global_elements/Navigation/lib/navOptions';
import { ActiveFacilityContext } from 'context/activeFacility';
import { UserContext } from 'context/user';
import { AccessType } from 'types/facilityUserAccount';
import { useTranslation } from 'react-i18next';
import SubmenuComponent from '../Submenu';
import SideNavLinkComponent from '../SideNavLink';
import { NavBarVariant } from './variants';

const NavBar = (props: NavBarProps): React.JSX.Element => {
  const { facility } = React.useContext(ActiveFacilityContext);
  const { user, isCoreMeasuresExpanded, isReferencesExpanded, SetIsCoreMeasuresExpanded, SetIsReferencesExpanded } = React.useContext(UserContext);
  const { t } = useTranslation('translation', { keyPrefix: 'app' });

  const canViewCoreMeasures = Boolean(facility.isCoreMeasures && user && (user.accessType === AccessType.ALL_ACCESS || user.accessType === AccessType.CORE_MEASURES));
  const canViewOutcomes = Boolean(facility.isOutcomes) && Boolean(user && (user.accessType === AccessType.ALL_ACCESS || user.accessType === AccessType.OUTCOMES));
  const getSubMenuExpanded = (menuTitle: string): boolean => {
    switch (menuTitle) {
      case 'Core Measures':
        return isCoreMeasuresExpanded;
      case 'References':
        return isReferencesExpanded;
      default:
        return false;
    }
  }

  const getSetSubMenuExpanded = (menuTitle: string): (isExpanded: boolean) => void => {
    switch (menuTitle) {
      case 'Core Measures':
        return SetIsCoreMeasuresExpanded;
      case 'References':
        return SetIsReferencesExpanded;
      default:
        return (isExpanded: boolean) => console.log(isExpanded);
    }
  }

  const navLinks = (role: UserRole | null | undefined, accountID: string | null | undefined): React.JSX.Element[] => {
    const userRoutes = GetNavOptions(role, accountID, canViewCoreMeasures, canViewOutcomes, facility?.pixDataEntry);
    return userRoutes.map(
      // eslint-disable-next-line no-nested-ternary
      (route: MenuItem): React.JSX.Element => (route.childItems.length > 0 ? (
        <SubmenuComponent
          childItems={route.childItems}
          title={route.menuTitle}
          isUHS={Boolean(facility.isUHS)}
          t={t}
          navBarVariant={props.variant}
          defaultExpanded={getSubMenuExpanded(route.menuTitle)}
          setParentExpanded={getSetSubMenuExpanded(route.menuTitle)}
        />
      ) : route.menuLink !== null ? (
        <SideNavLinkComponent
          route={route.menuLink}
          navLinkVariant={props.variant === NavBarVariant.ICON ? NavLinkVariant.ICON : NavLinkVariant.MAIN}
          isUHS={Boolean(facility.isUHS)}
          t={t}
          navBarVariant={props.variant}
        />
      ) : (
        <>Error</>
      )),
    );
  };

  return (
    <nav id="mho-nav-bar" className={`mho-nav-bar ${props.variant}`}>
      <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.START} align={AlignVariant.START} extraClasses="mho-nav-bar-container">
        <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.CENTER} align={AlignVariant.START}>
          {navLinks(props.userRole, user?.accountId)}
        </FlexContainer>
      </FlexContainer>
    </nav>
  );
};

export default React.memo(NavBar, (prevProps: Readonly<NavBarProps>, nextProps: Readonly<NavBarProps>) => prevProps.userRole === nextProps.userRole && prevProps.variant === nextProps.variant);
